import React, { Component } from "react"
import { navigate } from "gatsby"
import styled from 'styled-components'
import { handleLogin, isLoggedIn } from "../services/auth"
import { colors } from '../common'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: auto;
  background-color: ${colors.greyDarkest};
  padding: 2rem;
`

class Login extends Component {
  state = {
    username: ``,
    password: ``,
  }

  handleUpdate = event => {
    this.setState({
      [event.target.name]: event.target.value.toLowerCase(),
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    handleLogin(this.state)
  }

  render() {
    if (isLoggedIn()) {
      navigate(`/app/employees`)
    }

    return (
      <>
        <Form
          method="post"
          onSubmit={event => {
            this.handleSubmit(event)
            navigate(`/app/employees`)
          }}
        >
          <Label>
            Username
          </Label>
          <Input type="text" name="username" onChange={this.handleUpdate} />
          <Label>
            Password
          </Label>
          <Input
            type="password"
            name="password"
            onChange={this.handleUpdate}
          />
          <br />
          <Submit type="submit" value="Log In" />
        </Form>
      </>
    )
  }
}

export default Login

const Submit = styled.input`
  background-color: ${colors.green};
  color: #fff;
  padding: 1rem 2rem;
  text-transform: uppercase;
  font-size: 20px;
  width: 60%;
  letter-spacing: 1.5px;
  align-self: center;
  border: 1px solid #fff;
`

const Input = styled.input`
  border: 0;
  padding: 1rem;
  font-size: 16px;
  margin: 4px 0;
`

const Label = styled.label`
  margin: 8px 0;
  color: #fff;
`
